<template>
  <div v-if="visible" class="super-return">
    <p class="super-return-text">{{ label }} 계정으로 보는 중입니다.</p>
    <button type="button" class="super-return-btn" :disabled="leaving" @click="leave">
      슈퍼 계정으로 나가기
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, onUnmounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { alertError } from '@/services/appApi'
import { authStore } from '@/stores/auth'

const router = useRouter()
const leaving = ref(false)
const visible = computed(() => authStore.impersonating.value)
const label = computed(() => {
  const user = authStore.state.user
  if (!user) return '다른'
  if (user.appRole === 'CAREGIVER') return user.name || '요양보호사'
  return user.centerName || user.name || '센터'
})

watch(
  visible,
  (on) => {
    document.body.classList.toggle('has-super-return', on)
  },
  { immediate: true }
)
onUnmounted(() => {
  document.body.classList.remove('has-super-return')
})

const leave = async () => {
  if (leaving.value) return
  leaving.value = true
  try {
    await authStore.exitSuper()
    await router.replace('/owner')
  } catch (e) {
    await alertError('슈퍼 계정', e)
  } finally {
    leaving.value = false
  }
}
</script>
